// components/onboarding/GetStartedPopup.js
import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRight,
  faArrowLeft,
  faCheck
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import getStartedSteps from './getStartedSteps';
import { startTaskGuide } from './Coachmark';
import useOnboardingProgress from './useOnboardingProgress';

const isActivationKey = (e) => e.key === 'Enter' || e.key === ' ';

const TaskItem = ({ item, isDone, onSelect }) => {
  const { t } = useTranslation();

  const handleActivate = () => {
    onSelect(item.id);
  };
  const handleKeyDown = (e) => {
    if (isActivationKey(e)) {
      e.preventDefault();
      onSelect(item.id);
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleActivate}
      onKeyDown={handleKeyDown}
      className="d-flex align-items-center justify-content-between py-2 px-2 rounded-3 text-decoration-none transition-base user-select-none hover-bg-200 cursor-pointer text-dark"
    >
      <div className="d-flex align-items-center gap-3">
        <div
          className={`rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 align-self-center task-check-circle ${
            isDone
              ? 'bg-success text-white'
              : 'border border-2 border-300 bg-transparent'
          }`}
        >
          {isDone && (
            <FontAwesomeIcon icon={faCheck} className="font-size-10" />
          )}
        </div>
        <span
          className={`font-size-14 font-inter align-self-center ${
            isDone ? 'text-500 fw-normal' : 'fw-medium text-800'
          }`}
        >
          {t(item.labelKey)}
        </span>
      </div>
      <div className="text-400 pe-1">
        <FontAwesomeIcon icon={faArrowRight} className="font-size-11" />
      </div>
    </div>
  );
};

export const GetStartedChecklist = ({ onClose, onBack }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { completedTasks, totalCount, completedCount, progressPct } =
    useOnboardingProgress();

  const listItems = Object.values(getStartedSteps);

  const handleItemClick = (taskKey) => {
    if (onClose) onClose();
    startTaskGuide(taskKey, navigate);
  };

  return (
    <div className="bg-white dark__bg-1000 px-3 py-3 rounded-4">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <div className="d-flex align-items-center gap-2">
          {onBack && (
            <button
              type="button"
              className="btn btn-sm btn-link p-0 text-700 text-decoration-none shadow-none"
              onClick={onBack}
              aria-label="Back"
            >
              <FontAwesomeIcon icon={faArrowLeft} className="font-size-12" />
            </button>
          )}
          <h6 className="mb-0 fw-bold text-900 font-size-15 font-inter">
            {t('getStartedWithGetPlan')}
          </h6>
        </div>
        <button
          type="button"
          className="btn-close font-size-11 p-1"
          onClick={onClose}
          aria-label={t('close')}
        ></button>
      </div>

      <div className="text-primary fw-bold font-size-13 mb-3 font-inter">
        {completedCount} {t('ofText')} {totalCount} {t('completedText')}{' '}
        &bull; {progressPct}%
      </div>

      <ProgressBar
        now={progressPct}
        className="mb-3 rounded-pill progress-xs"
      />

      <div className="d-flex flex-column gap-2">
        {listItems.map((item) => (
          <TaskItem
            key={item.id}
            item={item}
            isDone={completedTasks?.includes(item.id)}
            onSelect={handleItemClick}
          />
        ))}
      </div>
    </div>
  );
};

const GetStartedPopup = () => null;

export default GetStartedPopup;
